module.exports = __webpack_public_path__ + "img/user.b0d029ef.png";